import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IPageResource } from "../types";

export type IPageTranslationUpdateMutationParameters = {
    content: string;
    locale: string;
    page: RelationalValue<IPageResource>;
    title: string;
};

export type IPageTranslationUpdateMutationResult = IPageResource;

export const pageTranslationUpdateMutation: IApiMutationFunction<IPageTranslationUpdateMutationParameters> = ({
    content,
    locale,
    page,
    title,
}) => ({
    method: "PUT",
    url: `/pages/${mapRelationalValue(page)}`,
    data: { title, content },
    headers: { "x-locale": locale },
});

export const usePageTranslationUpdateMutation = createApiMutationHook<
    IPageTranslationUpdateMutationParameters,
    IPageTranslationUpdateMutationResult
>(pageTranslationUpdateMutation);
